import CtrlModulosPage from './pages/CtrlModulosPage'
import ModuloUsuarioAssociacaoPage from './pages/ModuloUsuarioAssociacaoPage'
import ModuloMenuAssociacaoPage from './pages/ModuloMenuAssociacaoPage'

const routes = [
    {
        path: 'ctrl-modulos',
        name: 'ctrl-modulos',
        component: CtrlModulosPage,
        meta: { requiresModule: false }
    },
    {
        path: 'ctrl-modulos/:modulo/usuarios',
        name: 'modulo-usuarios',
        component: ModuloUsuarioAssociacaoPage,
        meta: { requiresModule: false }
    },
    {
        path: 'ctrl-modulos/:modulo/menus',
        name: 'modulo-menus',
        component: ModuloMenuAssociacaoPage,
        meta: { requiresModule: false }
    }
]

export default routes